module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBlack.95f59a8.ttf";